import { IntradayStrategyStartRequest } from '../../types/trading';
import {
  buildCapStart,
  buildMaStart,
  buildScheduleStart,
  CapFormState,
  defaultCapForm,
  defaultMaForm,
  defaultScheduleForm,
  MaFormState,
  ScheduleFormState,
  SIGNAL_REGISTRY,
  SignalMode,
} from './signalConfig';

export interface StrategyCardState {
  id: string;
  symbol: string;
  mode: SignalMode;
  maForm: MaFormState;
  percentCapForm: CapFormState;
  dollarCapForm: CapFormState;
  scheduleForm: ScheduleFormState;
  collapsed: boolean;
}

export type StrategyBuildResult =
  | { valid: true; request: IntradayStrategyStartRequest }
  | { valid: false; error: string };

let cardSequence = 0;

export const createStrategyCard = (): StrategyCardState => {
  cardSequence += 1;
  return {
    id: `card-${Date.now().toString(36)}-${cardSequence}`,
    symbol: '',
    mode: 'ma',
    maForm: defaultMaForm(),
    percentCapForm: defaultCapForm(),
    dollarCapForm: defaultCapForm(),
    scheduleForm: defaultScheduleForm(),
    collapsed: false,
  };
};

export const cardLabel = (card: StrategyCardState, index: number): string => {
  const symbol = card.symbol.trim().toUpperCase() || 'no symbol';
  return `#${index + 1} ${symbol} ${SIGNAL_REGISTRY[card.mode].label}`;
};

export const buildStrategyRequest = (
  card: StrategyCardState,
  index: number,
): StrategyBuildResult => {
  const symbol = card.symbol.trim().toUpperCase();
  if (!symbol) return { valid: false, error: 'select a symbol' };

  const built =
    card.mode === 'ma'
      ? buildMaStart(card.maForm)
      : card.mode === 'percent_cap'
        ? buildCapStart(card.percentCapForm, 'percent_cap')
        : card.mode === 'dollar_cap'
          ? buildCapStart(card.dollarCapForm, 'dollar_cap')
          : buildScheduleStart(card.scheduleForm);

  if (!built.valid || !built.params) {
    return { valid: false, error: built.error ?? 'invalid configuration' };
  }

  return {
    valid: true,
    request: {
      strategy_id: card.id,
      label: cardLabel(card, index),
      symbol,
      signal: SIGNAL_REGISTRY[card.mode].name,
      params: built.params,
    },
  };
};
